import { render, staticRenderFns } from "./PrivacyPolicyTemplate.vue?vue&type=template&id=0af75b58&scoped=true&"
import script from "./PrivacyPolicyTemplate.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyTemplate.vue?vue&type=style&index=0&id=0af75b58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af75b58",
  null
  
)

export default component.exports